import React from 'react';
import { JqueryClassFaker } from "components/JqueryClassFaker.jsx";


class StocksComponent extends React.Component {

	render() {
		const stocks = this.props.stocks;
		if(!stocks || !stocks.stock_icon || !stocks.detail) {
			return null;
		}
		const showDamage = this.props.showDamage === undefined ? true : this.props.showDamage;
		const showUpTo = this.props.showUpToStock || 99;
		const showDeaths = this.props.showDeaths === undefined ? true : this.props.showDeaths;
		let numberShown = 0;
		const stockComponents = [];
		for(let stock of stocks.detail) {
			stockComponents.push(
				<StockComponent
					stockIconUrl={stocks.stock_icon}
					stock={stock}
					key={stock.stock_number}
					showDamage={showDamage}
					showDeaths={showDeaths}
					isSelfDestruct={this.props.showSelfDestructs && stock.is_self_destruct}
				/>
			);
			numberShown++;
			if(numberShown >= showUpTo) {
				break;
			}
		}
		if(!stockComponents.length) {
			return null;
		}
		return (
			<div className="stocks has_stocks">
				{stockComponents}
			</div>
		);
	}
}

class StockComponent extends React.Component {
	render() {
		const stock = this.props.stock;
		const iconUrl = this.props.stockIconUrl;
		const classes = new JqueryClassFaker();

		if(this.props.showDeaths && (stock.time_lost !== null && stock.time_lost !== undefined)) {
			classes.add('dead');
		}
		if(this.props.isSelfDestruct) {
			classes.add('self_destructed');
		}
		const showDamage = this.props.showDamage && (!!stock.time_lost || !!stock.time_started);

		return (
			<span data-number={stock.stock_number} className={`stock_icon ${classes.toString()}`}>
				<img
					src={iconUrl}
				/>
				{showDamage && isNumeric(stock.damage_received) &&
				<span className='damage active'>{Number.parseInt(stock.damage_received)}</span>
				}
			</span>
		);
	}
}

export { StocksComponent };